// theme-sources/js/theme/features/cart-checkout.js

import { logger } from "../core/logger";

export function initCartCheckout() {
  logger.info("CartCheckout", "init");

  document.addEventListener("click", (event) => {
    const button = event.target.closest('button[name="checkout"]');
    if (!button) return;
    if (button.disabled) return;

    const label = button.querySelector("[data-checkout-label]");
    const loadingLabel = button.querySelector("[data-checkout-loading]");

    button.disabled = true;
    label?.classList.add("hidden");
    loadingLabel?.classList.remove("hidden");

    sessionStorage.setItem("_ZiggyCartReferrer", window.location.href);

    logger.info("CartCheckout", "redirecting to checkout");

    requestAnimationFrame(() => {
      window.location.href = "/checkout?logged_in=true";
    });

    /*
    window.location.href = "/checkout?logged_in=true";
    // 🔥 Reset immédiatement (avant que la page soit mise en cache)
    button.disabled = false;
    label?.classList.remove("hidden");
    loadingLabel?.classList.add("hidden");
    */
  });
}

/*
export function initCartCheckout() {
  logger.info("CartCheckout", "init");

  document.addEventListener("click", async (event) => {
    const button = event.target.closest('button[name="checkout"]');
    if (!button) return;

    // 🔒 Guard lié au bouton, pas global
    if (button.dataset.processing === "true") return;
    button.dataset.processing = "true";

    const label = button.querySelector("[data-checkout-label]");
    const loadingLabel = button.querySelector("[data-checkout-loading]");

    if (!IS_DEV) {
      button.disabled = true;
      label?.classList.add("hidden");
      loadingLabel?.classList.remove("hidden");
    }

    try {
      const cart = await fetch("/cart.js", {
        headers: { Accept: "application/json" },
      }).then((r) => r.json());

      await syncFakeProduct(cart);

      if (!IS_DEV) {
        window.location.href = "/checkout?logged_in=true";
        return;
      }
    } catch (error) {
      logger.error("CartCheckout", "checkout failed", error);

      button.disabled = false;
      label?.classList.remove("hidden");
      loadingLabel?.classList.add("hidden");
      button.dataset.processing = "false";
    }

    if (IS_DEV) {
      button.dataset.processing = "false";
    }
  });
}

/* ================================
   Fake sync — checkout only
================================ */
/*
async function syncFakeProduct(cart) {
  const items = cart.items || [];

  const fakeItem = items.find(
    (item) => Number(item.id) === Number(FAKE_VARIANT_ID),
  );

  const realItems = items.filter(
    (item) => Number(item.id) !== Number(FAKE_VARIANT_ID),
  );

  const hasSub = realItems.some((item) => !!item.selling_plan_allocation);

  const hasOneTime = realItems.some((item) => !item.selling_plan_allocation);

  const shouldHaveFake = hasSub && !hasOneTime;

  if (shouldHaveFake && !fakeItem) {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: FAKE_VARIANT_ID, quantity: 1 }],
      }),
    });
    return;
  }

  if (!shouldHaveFake && fakeItem) {
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates: { [fakeItem.key]: 0 },
      }),
    });
  }
}
  */
